export const PRIVACY_URL = 'https://www.finanzcheck.de/datenschutz-sc/';
export const IMPRINT_URL = 'https://www.finanzcheck.de/impressum/';
